import React, { useState } from 'react';
import Navbar from '../components/Navbar'; // Ensure the Navbar is correctly imported
import { motion } from 'framer-motion';

const playlists = [
  {
    id: "PLwfkYWhsJ_Lax1Lx6jijAaF1lFYSM1K1n",
    title: "Best of 2023",
  },
  {
    id: "PLwfkYWhsJ_LZd8oL4wAwLiRIkG4faXm60",
    title: "The Direct Path To Shell Scripting",
  },
  {
    id: "PLwfkYWhsJ_LaBXMkGGWbEfplHNDGoMGLj",
    title: "The Direct Path to MySQL DataBase",
  },
  {
    id: "PLwfkYWhsJ_LbjGo92o3jIDGKaSHqgpdME",
    title: "The Direct Path To Linux Ubuntu",
  },
  {
    id: "PLwfkYWhsJ_La-WtJEpSz3vBQYD7xiEM9-",
    title: "The Direct Path To Python Programming Language",
  },
  {
    id: "PLwfkYWhsJ_LaSdZqEain5h6DmsZLudgHR",
    title: "Oracle Sun Solaris",
  },
  {
    id: "PLwfkYWhsJ_LaOZcfZEgm1JgYl4yRSTMyy",
    title: "C, C++, VS Code IDE, Programming Languages and OS",
  },
  {
    id: "PLwfkYWhsJ_LaKcYIyAlU1qJYTZI2Wdksk",
    title: "Oracle VirtualBox",
  },
  {
    id: "PLwfkYWhsJ_LZZFScxfah_yjs8iKdlpYLr",
    title: "Windows OS and Virtualization (VirtualBox)",
  },
  // Add more playlists as needed
];

function PlayList() {
  const [selectedPlaylist, setSelectedPlaylist] = useState(null);
  const [darkMode, setDarkMode] = useState(false);

  return (
    <div className={darkMode ? "dark" : ""}>
      <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-white transition-colors">
        
        {/* Add Navbar here */}
        <Navbar />

        {/* Main Content */}
        <main className="max-w-6xl mx-auto px-4 py-12">
          <h2 className="text-3xl font-bold mb-8 text-center">MyWebUniversity Playlists</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {playlists.map((playlist) => (
              <div
                key={playlist.id}
                className="bg-white dark:bg-gray-800 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow"
              >
                <img
                  className="img-header"
                  src={`https://www.mywebuniversity.com/images/TN_MyWebLogo1.jpg`}
                  alt={playlist.title}
                  onError={(e) => {
                    e.target.src = "https://YouTube.com/@MyWebUniversity/Playlist";
                  }}
                />
                <div className="p-4">
                  <h3 className="text-lg font-semibold mb-2">{playlist.title}</h3>
                  <button
                    onClick={() => setSelectedPlaylist(playlist.id)}
                    className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
                  >
                    Watch Playlist
                  </button>
                </div>
              </div>
            ))}
          </div>
        </main>

        {/* Modal */}
        {selectedPlaylist && (
          <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
            <div className="bg-white dark:bg-gray-900 rounded-lg p-4 max-w-3xl w-full relative">
              <button
                onClick={() => setSelectedPlaylist(null)}
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-900 dark:hover:text-white"
              >
                ✖
              </button>
              <div className="aspect-video w-full">
                <iframe
                  src={`https://www.youtube.com/embed/videoseries?list=${selectedPlaylist}`}
                  title="YouTube Playlist"
                  className="w-full h-full rounded-lg"
                  frameBorder="0"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PlayList;
